import { Component, inject, OnDestroy, OnInit } from "@angular/core";
import { LiveTvService } from "../../../../../../shared/src/lib/services/live-tv.service";
import { MarketOpsService } from "../../content/market-layout/market/market-ops.service";
import { MatAccordion, MatExpansionModule } from "@angular/material/expansion";
import { NavigationStart, Router } from "@angular/router";
import { Subject } from "rxjs";
import { SafeUrlPipe } from "../../../../../../shared/src/lib/pipe/safe-url.pipe";
import { environment } from "../../../../../../shared/src/environments/environment";
import { MatTabsModule } from "@angular/material/tabs";
import { MatDialog } from "@angular/material/dialog";
import { MatIcon } from "@angular/material/icon";
import { FullScreenTvComponent } from "../../../components/full-screen-tv/full-screen-tv.component";
import { SnackbarService } from "../../../../../../shared/src/lib/services/snackbar.service";
import { takeUntil } from "rxjs/operators";

type Channel = {
  provider: string;
  url: string;
  MatchID: number;
  Channel: string;
  Name: string;
  Home: string;
  Away: string;
  Type: string;
  League: string;
  bid: string;
  TimeStart: string;
  NowPlaying: number;
  IsLive: number;
  State: string;
  UTCTimeStart: number;
  updateAt: string;
};

@Component({
  selector: "app-live-tv",
  imports: [MatAccordion, MatExpansionModule, SafeUrlPipe, MatTabsModule, MatIcon],
  templateUrl: "./live-tv.component.html",
  styleUrl: "./live-tv.component.scss",
})
export class LiveTvComponent implements OnInit, OnDestroy {
  readonly destroy$ = new Subject<void>();
  liveTvService = inject(LiveTvService);
  marketOps = inject(MarketOpsService);
  router = inject(Router);
  dialog = inject(MatDialog);
  tvChannels: Channel[] = [];
  expanded: boolean = false;
  snackbar = inject(SnackbarService);

  ngOnInit() {
    this.router.events.pipe(takeUntil(this.destroy$)).subscribe((event: any) => {
      if (event instanceof NavigationStart) {
        if (!event?.url?.includes("event-markets")) {
          this.handleTvReset();
        }
      }
    });
  }

  getSbSchedule(eventId: any): void {
    this.liveTvService
      .fetchSbTvSchedule({ eventId })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          const { data } = response || {};
          if (data) {
            const channelId = data?.SB?.Channel;
            if (!channelId) return;

            const streamUrl = `${environment.sbLiveTvURL}?chid=${channelId}`;
            const hasSB = this.tvChannels.some((ch) => ch.provider === "SB");

            this.tvChannels = hasSB
              ? this.tvChannels.map((ch) => (ch.provider === "SB" ? { ...ch, ...data?.SB, url: streamUrl } : ch))
              : [...this.tvChannels, { ...data?.SB, provider: "SB", url: streamUrl }];
            this.expanded = true;
          } else {
            this.snackbar.openSnackbar(
              {
                message: "No Live TV schedule found for this event.",
              },
              {
                horizontalPosition: "end",
              },
            );
            this.tvChannels = this.tvChannels.filter((ch) => ch.provider !== "SB");
          }
        },
      });
  }

  handleExpansion() {
    if (this.expanded) {
      this.handleTvReset();
    } else if (!this.expanded && this.marketOps.eventId) {
      this.getSbSchedule(this.marketOps.eventId);
    }
  }

  handleDialog(streamUrl: string) {
    this.dialog.open(FullScreenTvComponent, {
      data: streamUrl,
      height: "100%",
      width: "85%",
      maxWidth: "100%",
      maxHeight: "100%",
      exitAnimationDuration: 0,
    });
  }

  handleTvReset() {
    this.expanded = false;
    this.tvChannels = [];
  }

  get isEventMarkets() {
    return this.router.url.includes("event-markets");
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
